import { Fragment } from 'react';
import { compiler } from 'markdown-to-jsx';
// eslint-disable-next-line no-restricted-imports
import { Strong } from '@alfa-bank/site-deprecated-strong';
import { Link } from '@alfa-bank/site-link';

import { MarkdownListOverrider } from '../components/markdown-list-overrider/component';

export const mdPrefix = 'useMd:';

export const renderMd = (value: unknown, prefix = mdPrefix) => {
    if (typeof value !== 'string' || !value.startsWith(prefix)) {
        return value;
    }
    const regexp = new RegExp(`^${prefix}\\s*`);

    const mdValue = value.replace(regexp, '');

    // Проверяем есть ли текст перед списком в Markdown
    const hasTextBeforeList = !/^([*+-]|\d+\.)\s/.test(mdValue.trim());

    return compiler(mdValue, {
        overrides: {
            strong: {
                component: Strong,
            },
            p: {
                component: Fragment,
            },
            a: {
                component: Link,
            },
            /** @alfabank/site-lists не подходит, т.к. markdown-to-jsx рендерит <li> и в List рендерится <li>, соответственно рендерятся два <li>
             * Поэтому рендерим список с переопределенными стилями
             * **/
            ul: {
                component: MarkdownListOverrider,
                props: {
                    hasMarginTop: hasTextBeforeList,
                },
            },
            ol: {
                component: MarkdownListOverrider,
                props: {
                    type: 'ol',
                    hasMarginTop: hasTextBeforeList,
                },
            },
        },
    });
};
